import React from 'react';
import ReactDOM from 'react-dom';

import { RelatedProducersCarousel } from '/components/related-producers-carousel/components';

(() => {
    const relatedProducersCarousels = document.querySelectorAll('[data-related-producers-carousel]');

    relatedProducersCarousels.forEach((relatedProducersCarousel) => {
        const {
            producer,
        } = window;

        const {
            comparison,
        } = relatedProducersCarousel.dataset;

        ReactDOM.render(
            <RelatedProducersCarousel producer={producer} comparison={comparison} />,
            relatedProducersCarousel,
        );
    });
})();
